import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FieldViewChartLineComponent } from '../../field-view-chart-line/field-view-chart-line.component';
import { FieldViewChartPieComponent } from '../../field-view-chart-pie/field-view-chart-pie.component';
import { FieldViewChartService } from '../../services/field-view-chart.service';

@Component({
  selector: 'app-charts-panel',
  templateUrl: './charts-panel.component.html',
  styleUrls: ['./charts-panel.component.scss'],
  imports: [FieldViewChartPieComponent, FieldViewChartLineComponent, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartsPanelComponent {
  private readonly fieldViewChartDataService = inject(FieldViewChartService);

  readonly chartFilters = this.fieldViewChartDataService.fieldViewChartFilters;

  readonly chartDataIsLoadingSignal = this.fieldViewChartDataService.fieldViewChartDataIsLoading;
  readonly siteAnomalyChartDataSignal = this.fieldViewChartDataService.siteAnomalyChartData;
  readonly depthProfileChartDataSignal = this.fieldViewChartDataService.depthProfileChartData;
  readonly cpProfileChartDataSignal = this.fieldViewChartDataService.cpProfileChartData;
  readonly eventBreakdownChartDataSignal = this.fieldViewChartDataService.eventBreakdownChartData;
}
